/* eslint-disable no-useless-constructor */
/* eslint-disable no-unused-vars */
import React, { Component } from 'react';
import { connect } from 'react-redux'
import { Modal } from 'antd';
import { red, volcano, gold, yellow, lime, green, cyan, blue, geekblue, purple, magenta, grey, } from '@ant-design/colors';
import { 
     apiVmeetingSdkAppList, apiVmeetingSdkAppAdd, apiVmeetingSdkAppDel, apiVmeetingSdkAppMod, apiVmeetingSdkAppResetAppSecert
} from '../member/memberRD';
import {getLoginUserInfo} from '../login/loginRD'
import {
    HoForm, HoFormRowColInput, HoFormRowColInputNumber,
} from '../../util/formComponent';
import { 
    HoCard, HoBreadcrumb, hoMessage, HoTooltipIcon, HoRefreshButton, HoNewButton, HoAlertDialog, HoDeleteAlertDialog,
} from '../../util/hoComponent';
import { HoTable, hoTableInitPaginationInfo, 
    hoTableColumn, hoTableColumnDate, hoTableColumnAction, hoTableColumnTag, hoTableColumnTagButton, hoTableColumnActionButton 
} from '../../util/tableComponent';

import './vmeetingSdk.less'

class VmeetingSdkCT extends Component{
    constructor(props){
        super(props);

        // 主页面回调
        this.tblColOnChange = this.tblColOnChange.bind(this);
        
        // 主页面按钮
        this.mainRefreshOnClick = this.mainRefreshOnClick.bind(this);
        this.mainNewOnClick = this.mainNewOnClick.bind(this);

        this.tblRowDelOnClick = this.tblRowDelOnClick.bind(this);
        this.tblRowModOnClick = this.tblRowModOnClick.bind(this);
        this.tblRowActiveOnClick = this.tblRowActiveOnClick.bind(this);
        this.tblRowResetAppSecertOnClick = this.tblRowResetAppSecertOnClick.bind(this);
        this.tblRowForbiddenOnClick = this.tblRowForbiddenOnClick.bind(this);
        this.tblRowAccountOnClick = this.tblRowAccountOnClick.bind(this);

        let pag = hoTableInitPaginationInfo();
        pag.pagination.sort = {
            field: 'CreateTime',
            order: 1
        }

        const columns = [
            hoTableColumn('状态', 'IsActive', 'int', false, false, '7%', {
                render: (text, record) => {
                    let tags = [];
                    switch(record.IsActive){
                        case 1: 
                            tags.push({color: blue[3], tag:'启用'});
                            break;
                        case 0: 
                            tags.push({color: red[3], tag:'禁用'});
                            break;
                        default: 
                            break;
                    }
                    return hoTableColumnTagButton(tags);
                }
            }),
            hoTableColumn('App名称', 'AppName', 'str', false, false, '15%'),
            hoTableColumn('AppId', 'AppId', 'str', false, false, '15%'),
            hoTableColumn('AppSecert', 'AppCode', 'str', false, false, '10%'),
            hoTableColumn('能力', 'MaxAccount', 'str', false, false, '10%'),
            hoTableColumnDate('创建时间', 'CreateTime', false, '15%'),
            hoTableColumnAction('操作', 'operation', (text, record) => {

                let actions = [];
                if (record.AppName !== "mntn_camera") {
                    actions = [
                        { title: "重置AppSecert", onClick: this.tblRowResetAppSecertOnClick },
                        { title: "编辑", onClick: this.tblRowModOnClick },
                        { title: "删除", onClick: this.tblRowDelOnClick },
                        { title: "查看账户", onClick: this.tblRowAccountOnClick }
                    ]

                    if (!record.IsActive) {
                        actions.unshift({ title: "启用", onClick: this.tblRowActiveOnClick })
                    } else {
                        actions.unshift({ title: "禁用", onClick: this.tblRowForbiddenOnClick })
                    }
                } else {
                    actions = [
                        { title: "查看账户", onClick: this.tblRowAccountOnClick }
                    ]
                }

                return hoTableColumnActionButton(actions, record);
            }, '20%')
        ];

        this.state = {
            columns: columns,
            paginationInfo: pag,
        }
    }

    // 过滤、排序、分页发生变化
    tblColOnChange(paginationInfo){
        this.mainRefreshOnClick(null, paginationInfo)
    }

    // '刷新'按钮被点击
    mainRefreshOnClick(e, paginationInfo) {
        paginationInfo = paginationInfo || this.state.paginationInfo
        this.setState({
            status: 1,
        })
        apiVmeetingSdkAppList(this.props, paginationInfo,
            (dispatch, rsp, req) => {
                this.setState({
                    apps: rsp?.AppList,
                    total: rsp?.TotalNum,
                    status: 2,
                })
            }
        );
    }

    // '新增'按钮被点击
    mainNewOnClick() {
        this.setState({
            newPageVisible: true,
            data: {
                AppName: '',
            },
        })
    }

    // '编辑'按钮被点击
    tblRowModOnClick(e, record) {
        this.setState({
            modPageVisible: true,
            data: Object.assign({}, record),
        })
    }

    // '删除'按钮被点击
    tblRowDelOnClick(e, record) {
        Modal.confirm({
            title: "删除App",
            content: `是否删除${record.AppName}？`,
            onOk: () => {
                apiVmeetingSdkAppDel(this.props, record, () => {
                    this.mainRefreshOnClick();
                })
            },
            okText: "是的",
            cancelText: "我再想想",
            cancelButtonProps: { type: "danger" },
            maskClosable: true,
        })
    }

    // '重置AppSecert'按钮被点击
    tblRowResetAppSecertOnClick(e, record) {
        Modal.confirm({
            title: "重置AppSecert",
            content: `是否重置${record.AppName}的AppSecert？`,
            onOk: () => {
                apiVmeetingSdkAppResetAppSecert(this.props, record, () => {
                    this.mainRefreshOnClick();
                })
            },
            okText: "是的",
            cancelText: "我再想想",
            cancelButtonProps: { type: "danger" },
            maskClosable: true,
        })
    }

    // '查看账户'按钮被点击
    tblRowAccountOnClick(e, record) {
        window.goToMenu('member/sdk', `account/${record.Id}`, record)
    }

    // '启用'按钮被点击
    tblRowActiveOnClick(e, record) {
        Modal.confirm({
            title: "启用App",
            content: `是否启用${record.AppName}？`,
            onOk: () => {
                let newRecord = Object.assign({}, record);
                newRecord.IsActive = 1;
                apiVmeetingSdkAppMod(this.props, newRecord, () => {
                    this.mainRefreshOnClick();
                })
            },
            okText: "是的",
            cancelText: "我再想想",
            cancelButtonProps: { type: "danger" },
            maskClosable: true,
        })
    }

    // '禁用'按钮被点击
    tblRowForbiddenOnClick(e, record) {
        Modal.confirm({
            title: "禁用App",
            content: `是否禁用${record.AppName}？`,
            onOk: () => {
                let newRecord = Object.assign({}, record);
                newRecord.IsActive = 0;
                apiVmeetingSdkAppMod(this.props, newRecord, () => {
                    this.mainRefreshOnClick();
                })
            },
            okText: "是的",
            cancelText: "我再想想",
            cancelButtonProps: { type: "danger" },
            maskClosable: true,
        })
    }

    // 面包屑
    mkBreadcrumb() {
        return <HoBreadcrumb 
            items={[{title: "用户管理", url: "member"}, {title: "SDK用户"}]}
        />
    }

    mkHeaderInfo() {
        let { reqUserInfo } = this.props;
        let title = "SDK用户";
        let buttons = (<div>
            {reqUserInfo?.user?.role?.type === "superadmin" ? <HoNewButton onClick={this.mainNewOnClick} /> : undefined}
            <HoRefreshButton onClick={this.mainRefreshOnClick} />
        </div>);
        return { title: <span>{title}</span>, buttons: buttons};
    }

    mkNewModal(){
        const { newPageVisible, data } = this.state;

        return <HoAlertDialog
            title="新增App"
            visible={newPageVisible}
            onOkClick={() => {
                apiVmeetingSdkAppAdd(this.props, data,
                    () => {
                        this.setState({
                            newPageVisible: false,
                        }, () => {
                            this.mainRefreshOnClick();
                        })
                    }
                )
            }}
            onCancelClick={() => {
                this.setState({
                    newPageVisible: false,
                })
            }}
        >
            <HoForm >
                <HoFormRowColInput
                    label="App名称"
                    placeholder="请填写App名称"
                    colExtra={{ span:24 }}
                    inputExtra={{value: data?.AppName}}
                    onChange={(e) => {
                        data.AppName = e.target.value
                        this.setState({
                            data
                        })
                    }}
                />
                <div style={{ textAlign: 'left' }}>
                    <p style={{ color: "white" }}>*</p>
                </div>
            </HoForm>
        </HoAlertDialog>
    
    }
    
    mkModModal(){

        let { modPageVisible, data } = this.state;

        return <HoAlertDialog
            title="编辑App"
            visible={modPageVisible}
            onOkClick={() => {
                apiVmeetingSdkAppMod(this.props, data, () => {
                    this.setState({
                        modPageVisible: false,
                    }, () => {
                        this.mainRefreshOnClick();
                    })
                })
            }}
            onCancelClick={() => {
                this.setState({
                    modPageVisible: false,
                })
            }}
        >
            <HoForm >
                <HoFormRowColInput
                    label="名称"
                    placeholder=""
                    colExtra={{ span:24 }}
                    inputExtra={{value: data?.AppName}}
                    onChange={(e) => {
                        data.AppName = e.target.value
                        this.setState({
                            data
                        })
                    }}
                />
                <HoFormRowColInputNumber
                    label="最大账户数"
                    colExtra={{ span: 24 }}
                    inputExtra={{min: 1, max: 1000, step: 100, value: data?.MaxAccount, style:{width:'100%'}}}
                    onChange={(e) => {
                        data.MaxAccount = e
                        this.setState({
                            data
                        })
                    }}
                />
                <HoFormRowColInputNumber
                    label="最大呼叫数"
                    colExtra={{ span: 24 }}
                    inputExtra={{min: 1, max: 100, step: 10, value: data?.MaxCall, style:{width:'100%'}}}
                    onChange={(e) => {
                        data.MaxCall = e
                        this.setState({
                            data
                        })
                    }}
                />
                <div style={{ textAlign: 'left' }}>
                    <p style={{ color: "white" }}>*</p>
                </div>
            </HoForm>
        </HoAlertDialog>
    
    }

    mkTable() {
        let { columns, apps, status, total } = this.state;
        return <HoTable
            key="table"
            columns={columns}
            data={apps}
            rowKey={'Id'}
            loading={status === 1}
            onColumnChange={this.tblColOnChange}
            total={total}
        />
    }

    componentWillUnmount() {
        
    }

    componentDidMount() {
        this.mainRefreshOnClick();
    }

    render(){
        // 主页面
        const breadcrumbComponent = this.mkBreadcrumb();
        const { title, buttons } = this.mkHeaderInfo();
        const tableComponent = this.mkTable();

        const newComponent = this.mkNewModal();
        const modComponent = this.mkModModal();

        return (<div>
            {newComponent}
            {modComponent}
            {breadcrumbComponent}
            <HoCard key="card" title={title} buttons={buttons} >
                {tableComponent}
            </HoCard>
        </div>);
    }
}

const mapState = (state) => ({
    reqUserInfo: getLoginUserInfo(state), 
});


export default connect(
    mapState, 
    null
)(VmeetingSdkCT);

